package com.milta.core.localization.translations.nl

import com.milta.core.localization.SubscriptionExpiredStrings

internal val SubscriptionExpired = SubscriptionExpiredStrings(
    title = "Abonnement verlopen",
    driverSoloMessage = "Uw abonnement is verlopen. Verleng om door te gaan.",
    patronMessage = "Uw abonnement is verlopen. Uw team heeft geen toegang meer tot Milta.",
    driverUnderPatronMessage = "Het abonnement van uw organisatie is verlopen. Neem contact op met uw organisatie om uw toegang te herstellen.",
    renewButton = "Verlengen",
    close = "Sluiten",
    subscribeButtonTemplate = "Abonneren voor %s",
)
